import React from "react";
import { Button, Table } from "react-bootstrap";
import useProducts from "../../hooks/useProducts";
import "./ManageInventory.css";

import { Link } from "react-router-dom";
import { confirm } from "react-bootstrap-confirmation";

const ManageInventory = () => {
  const [products, setProducts] = useProducts();

  const handleRemoveItem = async (productId) => {
    const result = await confirm("Are you really sure?");
    if (result) {
      const url = `https://nameless-earth-37809.herokuapp.com/product/${productId}`;
      fetch(url, {
        method: "DELETE",
      })
        .then((res) => res.json())
        .then((data) => {
          const productsLeft = products.filter(
            (product) => product._id !== productId
          );
          setProducts(productsLeft);
        });
    }
  };

  return (
    <div className="mt-5 inventory-container d-flex justify-content-center flex-column align-items-center ">
      <Link
        className="btn btn-primary mx-auto d-block my-3 py-3 "
        as={Button}
        to={`/addNewProduct`}
      >
        Add New Item
      </Link>
      <Table
        striped
        bordered
        hover
        className="table-sm container table-responsive "
      >
        <thead>
          <tr>
            {/* <th>ID</th> */}
            <th>Product Name</th>
            <th>Quantity</th>
            <th>Price</th>
            <th>Supplier</th>
            <th>Remove</th>
          </tr>
        </thead>
        <tbody>
          {products.map((p) => {
            return (
              <tr key={p._id}>
                {/* <td>{p._id}</td> */}
                <td>
                  {" "}
                  <small>{p.name}</small>{" "}
                </td>
                <td>{p.quantity}</td>
                <td>{p.price}</td>
                <td>{p.supplier}</td>
                <td>
                  {" "}
                  <button
                    onClick={() => handleRemoveItem(p._id)}
                    className="btn btn-danger"
                  >
                    Delete
                  </button>{" "}
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
};

export default ManageInventory;
